var exports = {
  "Yy": "inlineReviewThreadHeading__Lpd8RP",
  "ms": "ReviewThreadContainer__dO-Lq2",
  "rK": "ResolvableContainer__dW4hi_",
  "DA": "ThreadLoading__GqU2An",
};

module.exports = exports;
